module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-actions"
  }, [_c('span', {
    class: {
      'c-actions__longPressText': true, 'is-active': _vm.showPressButton
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'c-actions__longPress': true, 'is-active': _vm.showPressButton
    },
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.handleStart($event)
      },
      "touchend": _vm.handleEnd,
      "touchcancel": _vm.handleEnd
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'c-actions__xplan': true, 'is-active': _vm.showXplanButton
    },
    on: {
      "click": _vm.handleClickXPlan
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7f43f726"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/show/Actions.vue
// module id = 205
// module chunks = 1